import defaultLang from '../language';

export const dispatchReportingEvent = (reportingData) => {
    const el = document.getElementsByTagName('html')[0];
    el.dispatchEvent(
        new CustomEvent('reportingData:update', {
            detail: reportingData,
        }),
    );
};
/* Old Product Recommender */
export function getGeneralReportingData(
    currentPage,
    siteSection,
    subSiteSection,
) {
    return {
        currentPage,
        siteSection,
        subSiteSection,
        applyPlatform: 'onboarding',
    };
}

export function getResultsReportingData(
    currentPage,
    siteSection,
    subSiteSection,
    productsRecommended,
) {
    return {
        currentPage,
        siteSection,
        subSiteSection,
        productsRecommended,
        applyPlatform: 'onboarding',
    };
}
const returnQuestionnaireForReportingData = (answers) => {
    const questionnaireObject = {
        goals: answers.get('P1Q1') || null,
        receivePayment: answers.get('P2Q1') || null,
        makePayment: answers.get('P3Q1') || null,
        manageBusiness: answers.get('P4Q1') || null,
    };
    return [questionnaireObject];
};
/* New Product Recommender */
export function getDPSGeneralReportingData(
    currentPage,
    formState = null,
    answers,
) {
    const reportingData = {
        currentPage,
        siteSection: defaultLang.siteCat.siteSection,
        subSiteSection: defaultLang.siteCat.subSiteSection,
        applyPlatform: defaultLang.siteCat.applyPlatform,
        correlationId: sessionStorage.getItem('correlationId'),
        preparerType: defaultLang.siteCat.preparerType,
        leadForm: defaultLang.siteCat.subSiteSection,
        formState,
        questionnaire: returnQuestionnaireForReportingData(answers),
    };
    return reportingData;
}

export function getDPSResultsReportingData(
    currentPage,
    productsSelected,
    errorMessage,
    answers,
) {
    const response = {
        currentPage,
        siteSection: defaultLang.siteCat.siteSection,
        subSiteSection: defaultLang.siteCat.subSiteSection,
        productsSelected,
        applyPlatform: defaultLang.siteCat.applyPlatform,
        correlationId: sessionStorage.getItem('correlationId'),
        preparerType: defaultLang.siteCat.preparerType,
        leadForm: defaultLang.siteCat.subSiteSection,
        formState: defaultLang.siteCat.formState.submit,
        questionnaire: returnQuestionnaireForReportingData(answers),
    };

    const result = errorMessage
        ? { ...response, errorMessage }
        : response;
    return result;
}
export function getDPSResultsOnClickEventReportingData(
    currentPage,
    productsSelected,
    onClickEvent,
) {
    return {
        currentPage,
        siteSection: defaultLang.siteCat.siteSection,
        subSiteSection: defaultLang.siteCat.subSiteSection,
        productsSelected,
        applyPlatform: defaultLang.siteCat.applyPlatform,
        onClickEvent,
        correlationId: sessionStorage.getItem('correlationId'),
        preparerType: defaultLang.siteCat.preparerType,
        leadForm: defaultLang.siteCat.subSiteSection,
        formState: defaultLang.siteCat.formState.submit,
    };
}

export function mapTealiumRecommendations(recommendations) {
    const parsedRecommendations = recommendations.map(
        (recommendation) => recommendation.title,
    );
    return parsedRecommendations.join(', ').toLowerCase();
}

export function tealiumUpdatedPageView() {
    if (window.publisherFW) {
        window.publisherFW.publishEvent(
            'pageView',
            window.reportingData,
        ); // call this function after the Data Layer Object
    }
}

export function tealiumUpdatedClick() {
    if (window.publisherFW) {
        window.publisherFW.publishEvent(
            'onClick',
            window.reportingData,
        ); // call this function after the Data Layer Object
    }
}

export function mapProductsSelected(recommendations) {
    const parsedRecommendations = recommendations.map(
        (recommendation) => recommendation.productId,
    );
    return `psbb:${parsedRecommendations.join(', ').toLowerCase()}`;
}

export const constructOnClickEvent = (
    pageName,
    tab,
    link,
    productId,
) => `${pageName}:${tab}${productId ? `:${productId}` : ''} ${link}`;

const joinArrayHelper = (array, joinSymbol) => array.join(joinSymbol);
const isEmptyObject = (object) => {
    const result =
        Object.keys(object).length === 0 &&
        object.constructor === Object;
    return result;
};
export const constructAnswerResponse = (answers) => {
    const answerMap = new Map();
    Object.entries(answers).forEach(([key, value]) => {
        const arr = [];
        Object.entries(value).forEach(([k, v]) => {
            const answerArray = isEmptyObject(v)
                ? []
                : v.map((item) => item.value);
            if (answerArray.length) {
                const answerArrayJoined = joinArrayHelper(
                    answerArray,
                    ',',
                );
                arr.push(`${k}:${answerArrayJoined}`);
                const val = joinArrayHelper(arr, '+');
                answerMap.set(key, val);
            }
        });
    });
    return answerMap;
};

export function getDPSResultsWithAnswersReportingData(
    currentPage,
    productsSelected,
    answers,
) {
    const response = {
        currentPage,
        siteSection: defaultLang.siteCat.siteSection,
        subSiteSection: defaultLang.siteCat.subSiteSection,
        productsSelected,
        applyPlatform: defaultLang.siteCat.applyPlatform,
        questionnaire: returnQuestionnaireForReportingData(answers),
        correlationId: sessionStorage.getItem('correlationId'),
        preparerType: defaultLang.siteCat.preparerType,
        leadForm: defaultLang.siteCat.subSiteSection,
        formState: defaultLang.siteCat.formState.submit,
    };
    return response;
}
